import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {fetchPeopleLevelInCampaignSuccess, fetchPeopleLevelInCampaignError, updatePeopleLevelInCampaignSuccess, updatePeopleLevelInCampaignError } from '../actions/PeopleLevelInCampaign';
import { getDocs, updateDoc } from 'firebase/services/peopleLevelInCampaign';
import {FETCH_PEOPLE_LEVEL_IN_CAMPAIGN, UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN} from 'constants/ActionTypes';

function* fetchPeopleLevelInCampaignRequest() {
  try {
    const fetchedPeopleLevelInCampaignList = yield call(getDocs);
    yield put(fetchPeopleLevelInCampaignSuccess(fetchedPeopleLevelInCampaignList));
  } catch (error) {
    console.log(error);
    yield put(fetchPeopleLevelInCampaignError(error));
  }
}

function* updatePeopleLevelInCampaignRequest({ params }) {
  try {
    const requests = params.map(param => call(updateDoc, {key: param.key, data: param}));
    const result = yield all(requests);
    yield put(updatePeopleLevelInCampaignSuccess(result));
  } catch (error) {
    console.log(error);
    yield put(updatePeopleLevelInCampaignError(error));
  }
}

export function* fetchPeopleLevelInCampaign() {
  yield takeEvery(FETCH_PEOPLE_LEVEL_IN_CAMPAIGN, fetchPeopleLevelInCampaignRequest);
}

export function* updatePeopleLevelInCampaign() {
  yield takeEvery(UPDATE_PEOPLE_LEVEL_IN_CAMPAIGN, updatePeopleLevelInCampaignRequest);
}

export default function* rootSaga() {
  yield all([fork(fetchPeopleLevelInCampaign), fork(updatePeopleLevelInCampaign)]);
}
